module.exports = __webpack_public_path__ + "Server-CalamariNeedsUpgrade.TentaclePassive.a762b482e25c1f2968d004d8449b56bd.hashedasset.svg";